module.exports = __webpack_public_path__ + "98f4afe7d084f5c87198bf2877cd10fe.jpg";